import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export async function sendADT1Email(emailParams: { companyName: string }) {
  try {
    const res = await fetcher(`${API_BASE_PATH}/send-adt1-email`, {
      method: 'POST',
      body: emailParams,
    });

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
